module.exports = __webpack_public_path__ + "img/pumping-card2.f4807385.png";